import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ConfirmButton } from '../../common/ConfirmButton';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ConfirmButtonWidget = () => {
    const component = useMemo(() => (_jsx(ConfirmButton, { variant: "outlined", confirmMessage: "Confirmation message", onConfirm: () => {
            // do your actual action here
        }, children: "Action" })), []);
    return {
        name: 'ConfirmButton',
        category: 'common',
        component,
    };
};
